import { WSTableCellProps } from "@wingspanhq/fe-component-library";
import { IInvoice } from "@wingspanhq/payments/dist/interfaces";
import { WorkLog, WorkLogStatus } from "@wingspanhq/wingspan-api-sdk";
import { WORK_LOG_STATUS_DISCARDED } from "../types";

type GetWorkLogStatusCellPropsParams = {
  workLog: WorkLog;
  invoice?: IInvoice;
};

export function getWorkLogPayeeStatusCellProps({
  workLog,
  invoice
}: GetWorkLogStatusCellPropsParams): WSTableCellProps {
  // "Discarded" is not in the SDK WorkLogStatus enum yet.
  if ((workLog.status as string) === WORK_LOG_STATUS_DISCARDED) {
    return {
      secondaryText: "Empty auto-submitted work log",
      pill: {
        text: "Discarded",
        theme: "error",
        icon: "exit-circle"
      }
    };
  }

  switch (workLog.status) {
    case WorkLogStatus.APPROVED:
      return {
        secondaryText: invoice?.invoiceNumber
          ? `Invoiced #${invoice.invoiceNumber}`
          : undefined,
        pill: {
          text: "Approved",
          theme: "success",
          icon: "check-circle"
        }
      };

    case WorkLogStatus.IN_PROGRESS:
      return {
        secondaryText: "Returned for editing",
        secondaryTextColor: "amber400",
        pill: {
          text: "Action required",
          theme: "warning",
          icon: "alert-circle"
        }
      };

    case WorkLogStatus.IN_REVIEW:
      return {
        secondaryText: "Awaiting client approval",
        pill: {
          text: "Submitted",
          theme: "blue",
          icon: "time"
        }
      };

    case WorkLogStatus.REJECTED:
      return {
        // TODO(v3): `invoiceId` renamed to `convertedResourceId` on v3 WorkLog.
        secondaryText: workLog.convertedResourceId
          ? "Cancelled invoice"
          : "Not invoiced",
        pill: {
          text: "Rejected",
          theme: "error",
          icon: "alert-circle"
        }
      };

    case WorkLogStatus.DRAFT:
    default:
      return {
        secondaryText: "Awaiting your submission",
        pill: {
          text: "Draft",
          theme: "neutral",
          icon: "draft"
        }
      };
  }
}
